import StatsTemplate from "./StatsTemplate";

export default function StatsUsers() {
  return <StatsTemplate entityLabel="Users" entitySingular="User" entityType="users" />;
}